/**
 * Pomocná funkce pro getMinSize a getMaxSize.
 * @returns Pokud je vstupní parametr číslo, tak k němu přidá jednotku (px).
 */
const formatValue = (value: string | number | undefined): string | undefined => (typeof value !== "number") ? value : `${value}px`;

/**
  * Převede velikosti do css function `min`, která vrací nejmenší hodnotu.
  * @param sizes Hodnoty velikosti.
  */
export const getMinSize = (...sizes: (string | number | undefined)[]): string | number | undefined => {
    const result = sizes.filter(size => size !== undefined && size !== "").map(formatValue);
    switch (result.length) {
        case 0: return undefined;
        case 1: return result[0];
        default: return `min(${result.join(", ")})`;
    }
};

/**
  * Převede velikosti do css function `max`, která vrací největší hodnotu.
  * @param sizes Hodnoty velikosti.
  */
export const getMaxSize = (...sizes: (string | number | undefined)[]): string | number | undefined => {
    const result = sizes.filter(size => size !== undefined && size !== "").map(formatValue);
    switch (result.length) {
        case 0: return undefined;
        case 1: return result[0];
        default: return `max(${result.join(", ")})`;
    }
};
